import { Moment } from "moment";

export interface SeriesData {
	date: string;
	value: number;
	isExtrapolated?: boolean;
}

export interface Data {
	date: Moment;
	value: number;
	isExtrapolated?: boolean;
}

export interface SeriesIntervalData {
	ask: SeriesData[];
	bid: SeriesData[];
	trade: SeriesData[];
	askRef: SeriesData[];
}

export interface IntervalData {
	ask: Data[];
	bid: Data[];
	trade: Data[];
	fundingSeries?: Data[];
	askRef: Data[];
}

export enum GRAPH_TYPE {
	ASK = "ask",
	MARKET = "market",
}

export enum LINE_TYPE {
	NORMAL = "normal",
	PRIMARY_ROUND = "primary-round",
	ASK_REF = "ask-ref",
}

export interface GraphData {
	listingDate?: string | null;
	showGraph: boolean;
	graphType: GRAPH_TYPE;
	showPrimaryRoundPricing?: boolean;
	daily: SeriesIntervalData;
	weekly: SeriesIntervalData;
	monthly: SeriesIntervalData;
	fundingSeries?: SeriesData[];
}

export interface Dimensions {
	boundedHeight: number;
	boundedWidth: number;
	marginTop: number;
	marginRight: number;
	marginBottom: number;
	marginLeft: number;
	width: number;
	height: number;
}

export enum PERIOD {
	THREE_MONTHS = "3M",
	SIX_MONTHS = "6M",
	YEAR_TO_DATE = "YTD",
	MAX = "MAX",
}

export enum INTERVAL {
	DAILY = "daily",
	WEEKLY = "weekly",
	MONTHLY = "monthly",
}
